import { DeviceMode } from '@vedalib/editor'
import * as R from 'ramda'
import React from 'react'

import { Tooltip } from 'components/uiKit/Dropdown'
import Icon from 'components/uiKit/Icon'
import { KitSize } from 'components/uiKit/KitTypes'
import type { ISelectOption } from 'components/uiKit/Select'
import { t } from 'services/Translation'

import * as s from './DeviceEmulator.module.scss'

const genDeviceOption =
  (device: DeviceMode) =>
  ({ width }: { width: number }): ISelectOption<number> => ({
    value: width,
    label: ({ type }) =>
      type === 'root' ? (
        <div className={s.deviceOption}>
          <Icon name={device} size={KitSize.S} />
          {width}px
        </div>
      ) : (
        `${width}px`
      ),
  })

export const DEVICE_MODE_OPTIONS = [
  {
    value: DeviceMode.desktop,
    textLabel: t('uiKit.tooltip.webVersion'),
    label: (
      <Tooltip overlay={t('uiKit.tooltip.webVersion')}>
        <Icon name={DeviceMode.desktop} size={KitSize.S} />
      </Tooltip>
    ),
  },
  {
    value: DeviceMode.tablet,
    textLabel: t('uiKit.tooltip.tabletVersion'),
    label: (
      <Tooltip overlay={t('uiKit.tooltip.tabletVersion')}>
        <Icon name={DeviceMode.tablet} size={KitSize.S} />
      </Tooltip>
    ),
  },
  {
    value: DeviceMode.mobile,
    textLabel: t('uiKit.tooltip.mobileVersion'),
    label: (
      <Tooltip overlay={t('uiKit.tooltip.mobileVersion')}>
        <Icon name={DeviceMode.mobile} size={KitSize.S} />
      </Tooltip>
    ),
  },
]

export const DEFAULT_DESKTOP_WIDTH = 1366

export const DESKTOP_SCREENS = [
  { width: 1025, height: 768 },
  { width: DEFAULT_DESKTOP_WIDTH, height: 768 },
  { width: 1920, height: 1080 },
  { width: 2560, height: 1440 },
]
export const DESKTOP_OPTIONS = DESKTOP_SCREENS.map(genDeviceOption(DeviceMode.desktop))

export const TABLET_SCREENS = [
  { width: 481, height: 600 },
  { width: 768, height: 600 },
  { width: 1024, height: 768 },
]
export const TABLET_OPTIONS = TABLET_SCREENS.map(genDeviceOption(DeviceMode.tablet))

export const MOBILE_SCREENS = [
  { width: 360, height: 700 },
  { width: 410, height: 800 },
  { width: 480, height: 915 },
]
export const MOBILE_OPTIONS = MOBILE_SCREENS.map(genDeviceOption(DeviceMode.mobile))

export const SCREENS = {
  [DeviceMode.desktop]: DEFAULT_DESKTOP_WIDTH,
  [DeviceMode.tablet]: 768,
  [DeviceMode.mobile]: 410,
}

export const MEDIA_QUERIES = {
  [DeviceMode.mobile]: `(max-width: ${R.last(MOBILE_SCREENS)?.width}px)`,
  [DeviceMode.tablet]: `(max-width: ${R.last(TABLET_SCREENS)?.width}px)`,
}
